import {Component, Input, OnDestroy, OnInit, Output, EventEmitter} from '@angular/core';
import {UserDataSourceService} from '../../core/data-sources/user-data-source.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-operators-table',
  templateUrl: './operators-table.component.html',
  styleUrls: ['./operators-table.component.scss']
})
export class OperatorsTableComponent implements OnInit, OnDestroy {

  @Input() usersHighlighted;
  @Output() usersHighlightedEvent = new EventEmitter();
  @Input() openedStart;

  openSubscription: Subscription;
  usersForklift;
  isAllChecked = false;
  isEmpty = false;
  filterName = '';

  get filteredUsers() {
    if (!this.filterName) {
      return this.usersForklift;
    }
    const term = this.filterName.toLowerCase();
    return this.usersForklift?.filter(u => u.username?.toLowerCase().includes(term));
  }

  get numberOfUsers(): string {
    const list = this.filteredUsers;
    return list?.length > 0 ? this.handleNumbersOfUsers(list) : '00';
  }

  constructor(private userDataSource: UserDataSourceService) { }

  ngOnInit(): void {
    this.openSubscription = this.openedStart.subscribe(async () => {
      await this.getUsers();
      this.isAllChecked = false;
    });
  }

  ngOnDestroy() {
    this.openSubscription.unsubscribe();
  }

  handleNumbersOfUsers(usersList) {
    if (usersList?.length > 0 && usersList?.length < 10) {
      return '0' + usersList?.length;
    } else if (usersList?.length > 10) {
      return usersList ?.length;
    } else {
      return '00';
    }
  }

  async getUsers() {
    try {
      this.usersForklift = (await this.userDataSource.getAll()).values;
      this.isEmpty = !this.filteredUsers?.length;
    } catch {
      // TODO handle error
    }
  }

  allChecked(isChecked) {
    this.isAllChecked = isChecked;
    this.usersHighlighted = [];
    if (isChecked) {
      for (const u of this.usersForklift) {
        this.usersHighlighted.push(u.id);
      }
    } else {
      this.usersHighlighted = [];
    }
    this.usersHighlightedEvent.emit(this.usersHighlighted);
  }

  onCheckboxChange(event) {
    if (event.checked) {
      this.usersHighlighted.push(event.source.value);
    } else {
      this.usersHighlighted.splice(this.usersHighlighted.indexOf(event.source.value), 1);
    }
    this.usersHighlightedEvent.emit(this.usersHighlighted);
  }
}
